import { useCallback, useEffect, useState } from 'react';

import { useNonRevalidatingFetcher } from './useNonRevalidatingFetcher';

interface Props {
  url: string;
}

const useRssFeed = ({ url }: Props) => {
  const fetcher = useNonRevalidatingFetcher<any>();
  const [hasFetched, setHasFetched] = useState(false);

  const fetchRSSFeed = useCallback(
    (url: string) => {
      fetcher.submit(JSON.stringify({ url }), {
        method: 'post',
        action: '/rss_feed',
        encType: 'application/json',
      });

      return fetcher.data;
    },
    [fetcher],
  );

  useEffect(() => {
    if (url && !hasFetched) {
      fetchRSSFeed(url);
      setHasFetched(true);
    }
  }, [url, hasFetched, fetchRSSFeed]);

  return {
    rssFeed: fetcher.data,
    isLoading: fetcher.state === 'loading' || !fetcher.data,
    isError:
      !!url &&
      fetcher.state !== 'idle' &&
      fetcher.state !== 'loading' &&
      fetcher.state !== 'submitting' &&
      !fetcher.data,
    fetchRSSFeed,
  };
};

export default useRssFeed;
